import { gsap } from 'gsap'

import Page from './../../classes/Page'

export default class extends Page {
  constructor () {
    super({
      id: 'journal',

      classes: {
        active: 'journal--active',
        buttonActive:'is-active',
      },

      element: '#main',
      elements: {
        // journal: '.detail',
        filterButtons: '[filter-button]',
        activeCategory: '[data-active-category]'
      }
    })
  }

  create () {
    super.create()

    this.isIndex = document.querySelector('[data-article-feed]') ? true : false // articles/index view
    this.isShow = document.querySelector('[data-article-post]') ? true : false // articles/show_archival view

    if (this.isIndex) {
      /* set initial category on filterButtons */
      this.category = this.elements.activeCategory.getAttribute('data-active-category')
      this.elements.filterButtons.forEach(button => {
        // console.log('button text', button.dataset.category)
        if (this.category == button.dataset.category) {
          button.classList.add(this.classes.buttonActive)
        }
      })
    }

    console.log('create JOURNAL page');

  }

  /**
   * Returns how many feed items are currently rendered, so the App can
   * save it alongside the scroll position — Livewire re-renders this feed
   * from its default page size on every fresh load, so a saved pixel
   * position is meaningless unless the same number of items are re-loaded
   * first. Undefined when not on the index view (nothing to restore).
   */
  getLoadedItemCount () {
    if (!this.isIndex) return undefined
    return document.querySelectorAll('[data-filter-item]').length
  }

  /**
   * Animations.
   */
  show (scrollHistory) {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.25
    }

    // Captured before the reset below, for use inside the async import's
    // .then() — by the time that runs, this.isPopState has already been
    // set back to false.
    const arrivedViaPopState = this.isPopState

    this.isPopState = false
    this.timelineIn = new gsap.timeline()

    if (this.isIndex) { // journal/index view
      import(
        '../../components/ArticleFeed.js' /* webpackChunkName: "components/ArticleFeed" */
      ).then((ArticleFeed) => {
        this.articleFeed = new ArticleFeed.default()

        // Unlike the lazy-loaded projects feed, this component's content is
        // already present in the initial HTML, so its 'articles-init' dispatch
        // can arrive before this async chunk import resolves and this.articleFeed
        // exists. Call init() directly here too; introTimeline()'s own guard
        // makes it safe to also run via the Livewire event if that fires later.
        this.articleFeed.init()

        const reveal = () => {
          this.timelineIn.to(this.element, {
            duration: this.duration,
            autoAlpha: 1
          })
        }

        // Restore feed scroll position (and matching active filter button)
        // here, on the incoming page, before it's revealed — not from
        // onPopState() on the outgoing page, where it used to fire while
        // that page was still fully visible and the new page's fetch
        // hadn't even resolved yet, producing a visible scroll jump on the
        // wrong page.
        if (arrivedViaPopState && !document.body.classList.contains('is-mobile')) {
          const savedItem = scrollHistory
            ? scrollHistory.positions.find(x => x.id == window.location.href)
            : null
          const savedCount = savedItem ? savedItem.itemCount : undefined
          const currentCount = document.querySelectorAll('[data-filter-item]').length

          // Livewire always re-renders this feed at its default page size
          // on a fresh load. If we'd loaded further than that before
          // leaving, a saved scroll position (or scroll-anchor target)
          // doesn't correspond to anything in the DOM yet — ask Livewire
          // to render up to where we were first, and wait for its
          // confirmation, before restoring position and revealing.
          if (typeof savedCount === 'number' && savedCount > currentCount) {
            let settled = false
            const finish = () => {
              if (settled) return
              settled = true
              clearTimeout(fallbackTimer)
              offReveal()
              try {
                this.articleFeed.scrollToAnchor()
                this.articleFeed.updateFilterButtons()
              } catch (error) {
                console.error('ArticleFeed popstate restore failed:', error)
              }
              reveal()
            }
            // Livewire never confirming (a dropped request, an event-name
            // mismatch) must never leave #main stuck hidden — same failure
            // mode fixed previously for the synchronous restore path.
            const fallbackTimer = setTimeout(finish, 3000)
            const offReveal = Livewire.on('articles-reveal', finish)
            Livewire.dispatch('load-initial', { amount: savedCount })
            return
          }

          try {
            this.articleFeed.scrollToAnchor()
            this.articleFeed.updateFilterButtons()
          } catch (error) {
            console.error('ArticleFeed popstate restore failed:', error)
          }
        }

        reveal()

        // this.articleFeed.setInitialVisibility()
        // .then(
        //   this.timelineIn.to(this.element, {
        //     duration: this.duration,
        //     autoAlpha: 1
        //   })
        // )

      })
    } else {

      this.timelineIn.to(this.element, {
        duration: this.duration,
        autoAlpha: 1
      })
    }

    return super.show(this.timelineIn)
  }

  hide () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.5
    }
    
    this.timelineOut = new gsap.timeline()

    this.timelineOut.to(this.element, {
      duration: this.duration,
      autoAlpha: 0
    })

    this.timelineOut.call(() => {
      this.destroy()
    })

    return super.hide(this.timelineOut)
  }

  /**
   * Events.
   */

  onTouchDown (event) {

    if (this.isIndex) {
      /* Filter Button States */
      if (event.target.closest('[filter-button]')) {
        console.log('clicked the filter')
        this.elements.filterButtons.forEach(button => {
          button.classList.remove('is-active')
        })
        event.target.classList.add('is-active')
      }

      /* Category Button on Post */
      if (event.target.closest('.btn__pill')) {
        this.category = event.target.getAttribute('filter-category')

        this.elements.filterButtons.forEach(button => {
          button.classList.remove('is-active')
          if (this.category == button.dataset.category) {
            button.classList.add(this.classes.buttonActive)
          }
        })

      }
    }

  }

  onPopState () {
    this.isPopState = true

    // Only teardown here — this fires on the outgoing page, which is still
    // fully visible and whose DOM is about to be replaced. Stop the
    // observer before that happens; anything that changes what's visibly
    // on screen (scroll position, filter button state) now happens in
    // show(), on the incoming page, before it's revealed.
    if (!document.body.classList.contains('is-mobile') && this.isIndex) {
      this.articleFeed.destroyLoadMoreObserver()
    }
  }

  addEventListeners () {

    Livewire.on('articles-init', category => {
      if (this.articleFeed) {
        this.articleFeed.init()
      }
        // alert('A post was InIt with the id of: ' + category);
    })

    Livewire.on('articles-filtered', category => {
      if (!document.body.classList.contains('is-mobile')) {
        this.articleFeed.scrollToTop()
      }
      this.articleFeed.setLoadMoreObserver()
    })

    Livewire.on('articles-updated', category => {
      // if (!document.body.classList.contains('is-mobile')) {
        this.articleFeed.setLoadMoreObserver()
      // }
    })

  }

  /**
   * Destroy.
   */
  destroy () {
    super.destroy()
  }
}
